import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Flex, SvgIcon, Text, BetaBadge } from 'Components/Base';
import { useOffset } from 'Context/LayoutContext/OffsetProvider';
import useCompatibleDisplay from 'Util/Hooks/useCompatibleDisplay';

import { SPACING_PADDING_TOP, HEADER_HEIGHT } from '../../Constant';

const IconWrapper = styled((props) => {
  return <Flex data-testid={'btn-course-info-back'} {...props} />;
})`
  cursor: pointer;
`;

const Header = (props) => {
  const { title, backToMyCourse, onClose } = props;
  const { t } = useTranslation('guidedPractice');
  const { topOffset } = useOffset();
  const { isMobile } = useCompatibleDisplay();
  return (
    <Flex
      padding={6}
      paddingLeft={isMobile ? 4 : 6}
      paddingTop={topOffset > 0 ? topOffset + SPACING_PADDING_TOP : 6}
      height={HEADER_HEIGHT}
      alignItems={'center'}
      backgroundColor={'white'}
      width={'100%'}
      style={{
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        position: 'sticky',
        top: 0,
        left: 0,
        zIndex: 1,
      }}
    >
      {backToMyCourse && (
        <IconWrapper onClick={backToMyCourse} style={{ flexShrink: 0 }}>
          <SvgIcon icon={SvgIcon.ICON_LIST.ARROW_LEFT} size={24} />
        </IconWrapper>
      )}

      <Flex flex={1} alignItems={'center'} justifyContent={'center'} gridColumnGap={'16px'}>
        <Text
          textStyle={'heading4'}
          fontWeight={'700'}
          whiteSpace={'nowrap'}
          overflow={'hidden'}
          textOverflow={'ellipsis'}
        >
          {title || t('HEADER.TITLE')}
        </Text>
      </Flex>

      {onClose && (
        <IconWrapper onClick={onClose} style={{ flexShrink: 0 }}>
          <SvgIcon icon={SvgIcon.ICON_LIST.CLOSE} size={24} />
        </IconWrapper>
      )}
    </Flex>
  );
};

Header.propTypes = {
  title: PropTypes.string,
  backToMyCourse: PropTypes.func,
  onClose: PropTypes.func,
};

export default Header;
